import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes, FaChevronDown } from 'react-icons/fa';

const Header = ({ market, content }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isMWO = market === 'mwo';

  const services = market === 'lu' ? [
    { name: 'For Small Businesses', path: '/services/small-business' },
    { name: 'Free IT Assessment',   path: '/services/assessment' },
    { name: 'Cloud Migration',      path: '/services/cloud' },
    { name: 'AI Consulting',        path: '/services/ai-consulting' },
    { name: 'Managed IT Support',   path: '/services/managed-it' },
    { name: 'Cybersecurity',        path: '/services/security' }
  ] : [
    { name: 'For Small Businesses', path: '/services/small-business' },
    { name: 'IT Consulting',        path: '/services/consulting' },
    { name: 'Managed IT Services',  path: '/services/managed-it' },
    { name: 'Cloud Solutions',      path: '/services/cloud' },
    { name: 'Cybersecurity',        path: '/services/security' },
    { name: 'AI & Automation',      path: '/services/ai-consulting' }
  ];

  const mobileLinks = [
    { name: 'Home',      path: '/',          indent: false },
    ...services.map(s => ({ ...s, indent: true })),
    { name: 'About',     path: '/about',     indent: false },
    { name: 'Insights',  path: '/insights',  indent: false },
    { name: 'Contact',   path: '/contact',   indent: false }
  ];

  return (
    <header
      className="site-header"
      style={{
        backgroundColor: isMWO ? '#0D0F14' : '#0F1B45',
        color: '#fff',
        borderBottom: isMWO ? '2px solid #00BCD4' : 'none',
        boxShadow: isMWO ? 'none' : '0 2px 20px rgba(15,27,69,0.3)'
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 clamp(16px, 4vw, 48px)' }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: isMWO ? '76px' : '68px'
        }}>

          {/* ── Logo ── */}
          <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            <img
              src={content.logo}
              alt={content.logoAlt}
              style={{ height: content.logoHeight || '48px', width: 'auto' }}
            />
          </Link>

          {/* ── Desktop Navigation ── */}
          <nav
            className="desktop-nav-items"
            style={{ display: 'flex', alignItems: 'center', gap: isMWO ? '36px' : '28px' }}
          >
            <Link to="/" className={isMWO ? 'mwo-nav-link' : 'mindit-nav-link'}>Home</Link>

            {/* Services dropdown */}
            <div className="nav-dropdown" style={{ position: 'relative' }}>
              <button className={isMWO ? 'mwo-nav-link' : 'mindit-nav-link'}>
                Services <FaChevronDown size={9} />
              </button>
              <div className="nav-dropdown-menu" style={{
                borderRadius: isMWO ? '0' : '8px'
              }}>
                {services.map((item, idx) => (
                  <Link
                    key={idx}
                    to={item.path}
                    className={isMWO ? 'dropdown-item-mwo' : 'dropdown-item-mindit'}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </div>

            <Link to="/about"    className={isMWO ? 'mwo-nav-link' : 'mindit-nav-link'}>About</Link>
            <Link to="/insights" className={isMWO ? 'mwo-nav-link' : 'mindit-nav-link'}>Insights</Link>
            <Link to="/contact"  className={isMWO ? 'mwo-nav-link' : 'mindit-nav-link'} style={{
              ...(isMWO ? {
                border: '1px solid rgba(0,188,212,0.4)',
                padding: '8px 20px',
                color: '#00BCD4'
              } : {})
            }}>Contact</Link>
          </nav>

          {/* ── Mobile Toggle ── */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="mobile-toggle"
            aria-label="Toggle menu"
            style={{ background: 'none', border: 'none', color: '#fff', fontSize: '22px', padding: '4px' }}
          >
            {mobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {/* ── Mobile Menu ── */}
      {mobileMenuOpen && (
        <div
          className="mobile-nav-open"
          style={{
            flexDirection: 'column',
            background: isMWO ? '#111318' : '#152266',
            padding: '20px clamp(16px, 4vw, 48px) 28px',
            borderTop: '1px solid rgba(255,255,255,0.08)',
            gap: '4px'
          }}
        >
          {mobileLinks.map((item, idx) => (
            <Link
              key={idx}
              to={item.path}
              onClick={() => setMobileMenuOpen(false)}
              style={{
                display: 'block',
                color: item.indent ? 'rgba(255,255,255,0.6)' : '#fff',
                textDecoration: 'none',
                padding: item.indent ? '7px 0 7px 20px' : '11px 0',
                fontSize: item.indent ? 'var(--ds-fz-mobile-item, 15px)' : 'var(--ds-fz-mobile-nav, 17px)',
                fontWeight: item.indent ? 400 : 600,
                borderLeft: item.indent ? '2px solid rgba(0,188,212,0.5)' : 'none',
                fontFamily: isMWO ? "var(--ds-font-display, 'Barlow Condensed', sans-serif)" : 'inherit',
                letterSpacing: isMWO ? '0.05em' : '0',
                textTransform: (isMWO && !item.indent) ? 'uppercase' : 'none'
              }}
            >
              {item.name}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};

export default Header;
